<template>
  <div class="form">
    <div class="form-body form-horizontal">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="col-md-4 control-label">{{ 'purchase_order.material.show_material' | trans }}:</label>
            <div class="col-md-8">
              <single-select
                  v-model="formMode"
                  :checked="formMode"
                  :options="modes"
                  :allow-empty="false"
                  :disabled="disabled"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-for="(dateList, dateListIndex) in formProduction" :key="dateList.id" class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="col-md-2 control-label bold">Sekcja {{ dateListIndex + 1 }}</label>
            <div class="col-md-2 pl-10 production-row-buttons">
              <button
                  v-if="dateListIndex === formProduction.length - 1"
                  class="btn btn-primary fa fa-plus"
                  :title="'grid.add_record' | trans"
                  :disabled="disabled"
                  @click="addNewFormProductionDateList"
              >
              </button>
              <button
                  v-if="formProduction.length > 1"
                  class="btn btn-danger fa fa-trash"
                  :title="'grid.remove' | trans"
                  :disabled="disabled"
                  @click="deleteFormProductionDateList(dateListIndex)">
              </button>
            </div>
          </div>
          <purchase-order-materials-production-row
              v-for="(productionRow, index) in dateList"
              :key="productionRow.id"
              :value="productionRow"
              :teams="teams"
              :brands="brands"
              :product-categories="productCategories"
              :disabled="disabled"
              :label="index ? '' : `${trans('production_reports.production_list.production_date')}:`"
              :can-delete="formProduction[dateListIndex].length !== 1"
              :can-add="formProduction[dateListIndex].length === index + 1"
              @input="updateFormProductionRow(dateListIndex, index, $event)"
              @add="addNewFormProductionRow(dateListIndex)"
              @delete="deleteFormProductionRow(dateListIndex, index)"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="col-md-4 control-label"></label>
            <div class="col-md-8">
              <button
                  class="btn btn-warning"
                  :disabled="isButtonDisabled"
                  @click="search(true)">
                {{ 'purchase_order.material.purchase_forecast' | trans }}
              </button>
              <button
                  class="btn btn-success"
                  :disabled="isButtonDisabled"
                  @click="search(false)">
                {{ 'purchase_order.material.search' | trans }}
              </button>
              <button
                  class="btn btn-success"
                  :disabled="isButtonDisabled"
                  @click="downloadXlsx(true)">
                {{ 'purchase_order.material.download_xlsx_file' | trans }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mode from '@js/forms/purchaseOrderMaterials/models/Mode'
import ProductionRow from '@js/forms/purchaseOrderMaterials/models/ProductionRow'
import PurchaseOrderMaterialsProductionRow from '@js/forms/purchaseOrderMaterials/ProductionRow.vue'
import SingleSelect from '@component/singleselect.vue'
import axios from 'axios'
import FileDownload from 'js-file-download'

const MODES = [
  new Mode('productions', 'production'),
  new Mode('forecast', 'forecast'),
]

export default {
  name: 'PurchaseOrderMaterialsSearch',
  components: {
    PurchaseOrderMaterialsProductionRow,
    SingleSelect
  },
  props: {
    disabled: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      formCategories: [],
      formMode: MODES[0].id,
      formProduction: [[new ProductionRow()]],
      brands: [],
      categories: [],
      teams: [],
      productCategories: [],
    }
  },
  computed: {
    isButtonDisabled() {
      return this.disabled || !this.isValidFormProduction
    },
    isValidFormProduction() {
      return this.formProduction.every((datelist) => {
        return datelist.every((productionRow) => {
          return productionRow.isValid
        })
      })
    }
  },
  created() {
    this.modes = MODES
  },
  mounted() {
    this.getBrands()
    this.getCategories()
    this.getTeams()
    this.getProductCategories()
  },
  methods: {
    updateFormProductionRow(dateListIndex, index, data) {
      this.formProduction[dateListIndex][index].update(data)
    },
    addNewFormProductionRow(dateListIndex) {
      this.formProduction[dateListIndex].push(new ProductionRow())
    },
    deleteFormProductionRow(dateListIndex, index) {
      this.formProduction[dateListIndex].splice(index, 1)
    },
    addNewFormProductionDateList() {
      this.formProduction.push([new ProductionRow()])
    },
    deleteFormProductionDateList(dateListIndex) {
      this.formProduction.splice(dateListIndex, 1)
    },
    search(isForecast) {
      this.$emit('request')
      axios.post(Routing.generate('api_search_purchase_order_material'), {
        forecast: isForecast,
        categories: this.formCategories,
        mode: this.formMode,
        onlyProduction: true,
        productions: this.formProduction,
        dateFrom: null,
        dateTo: null,
        brands: null,
        teams: null,
        allBrands: null,
        allTeams: null,
      }).then(response => {
        this.$emit('response', {
          isForecast: isForecast,
          items: response.data,
        })
      }, response => {
        this.handleAjaxError(response)
        this.$emit('response', {
          isForecast: isForecast,
          items: [],
        })
      })
    },
    downloadXlsx(isForecast) {
      this.loading++
      $('.btn').button('loading')
      let data = {
        forecast: isForecast,
        productions: this.formProduction,
        categories: this.formCategories,
        mode: this.formMode,
      }
      let url = Routing.generate('api_download_purchase_order_material')
      axios.post(url, data, {
        responseType: 'blob'
      }).then(response => {
        $('.btn').button('reset')
        this.loading--
        FileDownload(response.data, 'lista zakupowa.xlsx')
      }, response => {
        $('.btn').button('reset')
        this.loading--
        this.handleAjaxError(response)
      })
    },
    getBrands() {
      this.$emit('request')
      const url = Routing.generate('api_get_brands', { context: 'dropdown' })

      axios.get(url).then(response => {
        this.brands = response.data
      }, response => {
        this.handleAjaxError(response)
      }).finally(() => {
        this.$emit('response')
      })
    },
    getCategories() {
      this.$emit('request')
      const url = Routing.generate('api_get_tags', {
        type: 'portion_category',
        context: 'dropdown'
      })

      axios.get(url).then(response => {
        this.categories = response.data
      }, response => {
        this.handleAjaxError(response)
      }).finally(() => {
        this.$emit('response')
      })
    },
    getTeams() {
      this.$emit('request')
      const url = Routing.generate('api_get_active_production_teams', { context: 'dropdown' })

      axios.get(url).then(response => {
        this.teams = response.data
      }, response => {
        this.handleAjaxError(response)
      }).finally(() => {
        this.$emit('response')
      })
    },
    getProductCategories() {
      this.$emit('request')
      const url = Routing.generate('api_get_production_product_categories', { context: 'dropdown' })

      axios.get(url).then(response => {

        let categoryAll = {}
        categoryAll.id = -1
        categoryAll.name = 'Wszystkie'
        categoryAll.systemValue = 'ALL'

        let productCategories = response.data
        productCategories.push(categoryAll)

        this.productCategories = productCategories
      }, response => {
        this.handleAjaxError(response)
      }).finally(() => {
        this.$emit('response')
      })
    },
  }
}
</script>

<style scoped>
.btn.btn-success {
  margin-left: 5px;
  padding-right: 12px;
}
</style>
